export default __webpack_public_path__ + "media/images/buttons-4679b87bc744dc5218a3a7e22ea9c27e.gif";